import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import supabase from '../lib/supabase';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (error) setError(error.message);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#f6f7f4]">
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-sm p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-10 h-10 rounded-lg bg-[#2d5016] flex items-center justify-center">
            <span className="text-white font-bold">A</span>
          </div>
          <div>
            <div className="text-sm font-semibold">AceRent</div>
            <div className="text-xs text-gray-500 uppercase tracking-wider">Partner</div>
          </div>
        </div>

        <h1 className="text-xl mb-1">Sign in</h1>
        <p className="text-sm text-gray-500 mb-6">Coaches and club staff.</p>

        <form onSubmit={onSubmit} className="space-y-3">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
            className="w-full h-11 px-3 rounded-lg border border-gray-300 focus:border-[#2d5016] focus:outline-none text-sm"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            className="w-full h-11 px-3 rounded-lg border border-gray-300 focus:border-[#2d5016] focus:outline-none text-sm"
          />
          {error && (
            <div className="text-xs text-red-600 bg-red-50 border border-red-200 rounded-md p-2">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            className="w-full h-11 rounded-lg bg-[#2d5016] hover:bg-[#1a3010] text-white text-sm flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
            Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
